import {Card, CardActionArea, CardContent, Stack, Typography} from '@mui/material';
import Icon from 'presentation/icons';
import {translations} from 'presentation/translations-new';
import React from 'react';
import {AppointmentCardProps} from '../AppointmentCard/types';
import {useAttachmentCard} from './hooks/useAttachmentCard';
import {StyledIcon} from './styles';

const {
	appointmentCard: {uploadAttachments},
} = translations['pt-br'].privateFlow.myAppointments;

export const AttachmentCard = ({appointment}: AppointmentCardProps) => {
	const {theme, handleGoToDetails} = useAttachmentCard({appointment});

	return (
		<Card elevation={0}>
			<CardActionArea
				onClick={handleGoToDetails}
				sx={{
					height: '100%',
					backgroundColor: theme.colors.gray['10Percent'],
				}}>
				<CardContent
					sx={{
						height: '100%',
						display: 'flex',
						flexDirection: 'row',
						alignItems: 'center',
						justifyContent: 'space-between',
					}}>
					<Stack flexDirection="row" alignItems="center" gap={2}>
						<StyledIcon name="attach-file-filled" />

						<Stack>
							<Typography variant="body2" color="text.primary">
								{uploadAttachments.description}
							</Typography>
						</Stack>
					</Stack>
					<Icon
						name="arrow-right"
						color={theme.palette.primary.main}
						size={24}
						style={{marginLeft: 'auto', flexShrink: 0}}
					/>
				</CardContent>
			</CardActionArea>
		</Card>
	);
};
